export const goodsHolderItemsTableColumns = [
  { Header: 'Material Code', accessor: 'productCode' },
  { Header: 'Size', accessor: 'sizeCode' },
  { Header: 'Division', accessor: 'divisionCode' },
  { Header: 'Total Units', accessor: 'packedQuantity' },
  { Header: 'Delivery Note', accessor: 'deliveryNoteNumber' },
  { Header: 'Sales Order', accessor: 'salesOrderNumber' },
  { Header: 'Purchase Order', accessor: 'purchaseOrderNumber' },
  { Header: 'Customer Purchase Order', accessor: 'customerPurchaseOrderNumber' },
]
